import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  TextField,
  Typography,
} from "@mui/material";
import FormField from "components/FormField";
import MDBox from "components/MDBox";
import { useAuthContext } from "context/AuthContext";
import { useState } from "react";

const CooperatedFormDescription = ({
  label,
  cooperated,
  pas,
  pa,
  setPa,
  setInput,
}) => {
  const [step, setStep] = useState(false);

  const { user } = useAuthContext();

  const [inputPa, setInputPa] = useState("");

  const PA = (pa_uuid) => pas.filter((obj) => obj?.uuid === pa_uuid)[0];

  return (
    <Accordion
      expanded={step}
      onChange={() => setStep(!step)}
      slotProps={{ transition: { timeout: 400 } }}
      sx={{
        "& .MuiAccordion-region": {
          height: step ? "auto" : 0,
        },
        "& .MuiAccordionDetails-root": {
          display: step ? "block" : "none",
        },
      }}
    >
      <MDBox p={3}>
        <MDBox>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography>{label}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <MDBox mt={1.625}>
              <Autocomplete
                value={pa ?? PA(pa) ?? ""}
                onChange={(_, newValue) => {
                  setPa(newValue);
                }}
                inputValue={inputPa}
                onInputChange={(_, newInputValue) => {
                  setInputPa(newInputValue);
                }}
                getOptionLabel={(pa) =>
                  pa ? `${pa?.number} - ${pa?.name}` : ""
                }
                options={pas}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label="Selecione o P.A."
                    required
                  />
                )}
              />

              {user?.profile === 1 && user?.company_id && (
                <FormField
                  type="text"
                  label="Descrição Privada"
                  name="private_description"
                  value={cooperated?.private_description}
                  multiline
                  rows={5}
                  placeholder="Descrição Privada"
                  onChange={setInput}
                />
              )}
            </MDBox>
          </AccordionDetails>
        </MDBox>
      </MDBox>
    </Accordion>
  );
};

export default CooperatedFormDescription;
